import {
  Box,
  createStyles,
  makeStyles,
  Theme,
  Typography,
} from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import React, { FC, useContext, useState } from 'react';
import EditBusinessAPAModal from './Modals/EditBusinessAPAModal';
import { BusinessContext } from '../BusinessProvider/BusinessProvider';
import { formatName } from '../../../utils/common';

const BusinessEditAPA: FC = () => {
  const classes = useStyles();
  const { businessState, canEditBusiness } = useContext(BusinessContext);
  const [opened, setOpened] = useState<boolean>(false);

  const {
    apa: { firstName, lastName },
  } = businessState;

  return (
    <>
      <Box className={classes.container}>
        <Typography>
          Apporteur : {formatName({ firstName, lastName })}
        </Typography>
        {canEditBusiness && (
          <EditIcon className={classes.icon} onClick={() => setOpened(true)} />
        )}
      </Box>
      {opened && <EditBusinessAPAModal onClose={() => setOpened(false)} />}
    </>
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      display: 'flex',
      alignItems: 'center',
    },
    icon: {
      height: 15,
      color: '#FF4340',
      cursor: 'pointer',
    },
  }),
);

export default BusinessEditAPA;
